export const truncateTextToLines = (
  text: string,
  maxLines: number = 2,
  wordsPerLine: number = 10,
): string => {
  const maxWords = maxLines * wordsPerLine;
  const words = text.split(" ");
  const truncatedWords = words.slice(0, maxWords).join(" ");
  return truncatedWords + (words.length > maxWords ? "..." : "");
};
